import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { UpdateDirectDebit, UpdateDirectDebitVariables }
  from '@/graphql/contracts/_generated_/updateDirectDebit.mutation';
import UpdateDirectDebitMutation from '@/graphql/contracts/updateDirectDebit.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import { fieldVerificationRefreshTrigger } from '@/pages/ContractDetails/ContractIq/ContractIq.state';

export default function useUpdateDirectDebit(contractId: UUID) {
  const setRefreshTrigger = useSetRecoilState(fieldVerificationRefreshTrigger);

  const [_updateDirectDebit, { loading }] = useMutation<UpdateDirectDebit, UpdateDirectDebitVariables>(
    UpdateDirectDebitMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => {
        notificationService.open({
          title: 'Direct Debit',
          text: 'Direct Debit successfully changed',
          type: 'success'
        });
        setRefreshTrigger((prev) => prev + 1);
      }
    }
  );

  const updateDirectDebit = (directDebitType: string | null) => {
    _updateDirectDebit({
      variables: {
        contractId,
        directDebitType
      }
    });
  };

  return {
    updateDirectDebit,
    isLoadingUpdateDirectDebit: loading,
  } as const;
}
